module.exports = __webpack_public_path__ + "img/art-slide-2-xl.62c7294.webp";